<template>
  <v-container fluid>
    <v-layout align-start>
      <v-flex>
        <v-row class="mt-n6 mb-2" no-gutters justify="center">
          <span style="font-size: 34px; color: #616161">
            <v-icon large class="pr-1 pb-2">fork_right</v-icon>
            Movimiento entre ubicaciones</span
          >
        </v-row>
        <v-card flat>
          <v-row justify="center">
            <v-col cols="12" md="2" class="pt-0 pb-2 pr-0">
              <v-autocomplete
                v-model="business_selected"
                :items="$store.state.auth.bussines_units"
                label="Unidad de negocio"
                color="cyanText"
                prepend-inner-icon="corporate_fare"
                outlined
                dense hide-details
                required
                @change="refresFilters()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" class="pt-0 pb-2 pr-0">
              <v-autocomplete
                v-model="location_selected"
                :items="locationsFrombusiness"
                color="cyanText"
                label="Location"
                prepend-inner-icon="my_location"
                outlined hide-details
                return-object
                required
                dense
                @change="refresFilters()"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="4" class="pt-0 mb-2">
              <v-menu
                v-model="warehouse_from_menu_open"
                :close-on-content-click="false"
                :max-width="600"
                offset-y 
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="warehouse_from_display_text"
                    label="Ubicacion origen"
                    prepend-inner-icon="mdi-warehouse"
                    append-icon="mdi-chevron-down"
                    readonly
                    outlined
                    dense :disabled="page==2"
                    v-bind="attrs"
                    v-on="on"  hide-details
                    @click="loadWarehouseTree"
                  ></v-text-field>
                </template>

                <v-card class="warehouse-select-card" elevation="8">
                  <v-card-title class="warehouse-select-title pa-4">
                    <div class="d-flex align-center flex-grow-1">
                      <v-avatar color="primary" size="40" class="mr-3">
                        <v-icon color="white">mdi-warehouse</v-icon>
                      </v-avatar>
                      <div>
                        <h4 class="warehouse-title">Seleccionar Ubicacion</h4>
                        <p class="warehouse-subtitle mb-0">
                          {{ warehouseTree.length }} Ubicacion{{
                            warehouseTree.length !== 1 ? "es" : ""
                          }}
                          disponible{{ warehouseTree.length !== 1 ? "s" : "" }}
                          <span
                            v-if="searchTerm && searchMatchCount"
                            class="search-results ml-2"
                          >
                            ({{ searchMatchCount }} encontrado{{
                              searchMatchCount !== 1 ? "s" : ""
                            }})
                          </span>
                        </p>
                      </div>
                    </div>

                    <div class="warehouse-controls">
                      <!-- Search mejorado -->
                      <v-text-field
                        v-model="searchTerm"
                        prepend-inner-icon="mdi-magnify"
                        label="Buscar Ubicacion..."
                        outlined
                        dense
                        hide-details
                        clearable
                        class="search-field mr-2"
                        @click:clear="clearSearch"
                      >
                        <template
                          v-slot:append-outer
                          v-if="searchTerm && searchMatchCount"
                        >
                          <v-chip x-small color="success" class="ml-1">
                            {{ searchMatchCount }}
                          </v-chip>
                        </template>
                      </v-text-field>

                      <!-- Expand/Collapse buttons -->
                      <div class="d-flex">
                        <v-btn
                          icon
                          small
                          color="primary"
                          class="mr-1"
                          title="Expandir todos los nodos"
                          @click="expandAllNodes"
                          :loading="loading"
                        >
                          <v-icon small>mdi-arrow-expand-all</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          small
                          color="grey darken-1"
                          title="Contraer todos los nodos"
                          @click="collapseAllNodes"
                          :loading="loading"
                        >
                          <v-icon small>mdi-arrow-collapse-all</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-card-title>

                  <v-divider></v-divider>

                  <v-card-text
                    class="pa-0"
                    style="max-height: 400px; overflow-y: auto"
                  >
                    <div v-if="loadingWarehouses" class="pa-4 text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="24"
                        class="mr-2"
                      ></v-progress-circular>
                      Cargando ubicaciones...
                    </div>
                    <div
                      v-else-if="currentTreeData.length === 0"
                      class="empty-warehouse-state"
                    >
                      <div class="empty-warehouse-content">
                        <v-icon size="60" color="grey lighten-1">
                          {{
                            searchTerm
                              ? "mdi-magnify-scan"
                              : "mdi-warehouse-off"
                          }}
                        </v-icon>
                        <h4 class="empty-warehouse-title mt-3 mb-2">
                          {{
                            searchTerm
                              ? "No se encontraron ubicaciones"
                              : "No hay ubicaciones disponibles"
                          }}
                        </h4>
                        <p class="empty-warehouse-subtitle grey--text mb-3">
                          {{
                            searchTerm
                              ? "Intenta con otros términos de búsqueda"
                              : "Selecciona otra ubicación"
                          }}
                        </p>
                        <v-btn
                          v-if="searchTerm"
                          small
                          color="grey darken-1"
                          text
                          @click="clearSearch"
                        >
                          <v-icon left small>mdi-close</v-icon>
                          Limpiar Búsqueda
                        </v-btn>
                      </div>
                    </div>
                    <v-treeview
                      v-else
                      ref="warehouseTree"
                      :items="currentTreeData"
                      :search="internalSearchTerm"
                      :filter="customFilter"
                      item-key="id"
                      item-text="name"
                      item-children="children"
                      dense
                      hoverable
                      activatable
                      selectable
                      single-select
                      expand-icon="mdi-chevron-right"
                      selected-color="primary"
                      :active.sync="warehouseActive"
                      :selected.sync="warehouseSelected"
                      :open.sync="expandedNodes"
                      return-object
                      @update:active="handleActiveUpdate"
                      @update:selected="handleSelectedUpdate"
                      @update:open="handleOpenUpdate"
                      class="warehouse-tree pa-2"
                    >
                      <template v-slot:prepend="{ item }">
                        <v-icon
                          :color="
                            isNodeHighlighted(item)
                              ? 'primary'
                              : item.active
                              ? 'primary lighten-1'
                              : 'grey'
                          "
                          :class="{
                            'pulse-icon': searchTerm && isNodeHighlighted(item),
                          }"
                        >
                          {{
                            item.children && item.children.length
                              ? "mdi-warehouse"
                              : "mdi-package-variant-closed"
                          }}
                        </v-icon>
                      </template>

                      <template v-slot:label="{ item }">
                        <div class="d-flex align-center warehouse-node">
                          <div>
                            <div
                              class="warehouse-name"
                              v-html="highlightSearchText(item.name)"
                            ></div>
                            <div
                              class="warehouse-details d-flex align-items-center"
                            >
                              <v-chip
                                x-small
                                :color="item.active ? 'success' : 'grey'"
                                text-color="white"
                                class="mr-2"
                                v-if="item.active !== undefined"
                              >
                                {{ item.active ? "Activo" : "Inactivo" }}
                              </v-chip>
                              <v-chip
                                v-if="item.children && item.children.length"
                                x-small
                                color="primary"
                                text-color="white"
                                class="mr-2"
                              >
                                Grupo
                              </v-chip>
                              <span
                                v-if="
                                  item.location_description_short ||
                                  item.location_description_long
                                "
                                class="location-info caption grey--text"
                                v-html="
                                  highlightSearchText(
                                    item.location_description_short ||
                                      item.location_description_long ||
                                      ''
                                  )
                                "
                              ></span>
                            </div>
                          </div>
                        </div>
                      </template>
                    </v-treeview>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-3">
                    <v-btn
                      text
                      color="grey darken-1"
                      @click="warehouse_from_menu_open = false"
                    >
                      <v-icon left small>mdi-close</v-icon>
                      Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-col>
            <v-col md="4" class="pt-0 mb-2">
              <v-autocomplete
                :items="warehouses_to"
                v-model="warehouse_selected"
                label="Ubicacion destino"
                outlined  hide-details
                @change="get_history()"
                dense :disabled="page==2"
                return-object
                item-text="name"
                item-id="id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-stepper flat v-model="page">
            <v-stepper-items>
              <v-stepper-content :step="1" class="pa-0">
                <v-card outlined>
                  <v-data-table
                    :headers="history_headers"
                    :search="search_history"
                    :items="item_history"
                    :items-per-page="10"
                    height="48vh"
                    fixed-header
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <span>Movimientos: {{ item_history.length }}</span>
                        <v-spacer></v-spacer>
                        <v-text-field
                          class="text-xs-center"
                          v-model="search_history"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                          outlined
                          dense
                        >
                        </v-text-field>
                        <v-spacer></v-spacer>
                        <v-divider class="mx-3" inset vertical></v-divider>
                        <v-btn
                          v-if="hasFeature('INV-151')"
                          color="success"
                          class="mr-2"
                          outlined
                          @click="new_transfer()"
                        >
                          Nuevo movimiento
                          <v-icon>add</v-icon>
                        </v-btn>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.code`]="{ item }">
                      <v-hover v-slot="{ hover }">
                        <span
                          @click="view_transfer(item.warehouse_transfer_id)"
                          class="origin-link"
                          :class="{ 'origin-link--hover': hover }"
                        >
                          {{ item.transfer_code }}
                        </span>
                      </v-hover>
                    </template>
                  </v-data-table>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
            <v-stepper-items>
              <v-stepper-content :step="2" class="pa-0">
                <v-card outlined>
                  <v-data-table
                    :headers="headersArticle"
                    :search="search"
                    :items="item_list"
                    height="48vh"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-btn color="error" @click="page = 1" dense outlined
                          >Volver</v-btn
                        >
                        <v-divider class="mx-3" inset vertical></v-divider>
                        <span>Items: {{ item_list.length }}</span>
                        <v-spacer></v-spacer>
                        <v-text-field
                          class="text-xs-center"
                          v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                          outlined
                          dense
                        >
                        </v-text-field>
                        <v-spacer></v-spacer>                        
                        <v-btn
                          color="primary"
                          class="mr-2"
                          outlined
                          v-if="can_edit"
                          @click="openDialogAddItem()"
                        >
                          Agregar item
                          <v-icon>add</v-icon>
                        </v-btn>
                        <v-divider class="mx-3" inset vertical></v-divider>
                        <v-btn
                          color="success"
                          class="mr-2"
                          outlined
                          @click="validate_save()"
                        >
                          Guardar
                          <v-icon>save</v-icon>
                        </v-btn>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.item_image`]="{ item }">
                      <v-avatar size="40">
                        <v-img :src="item.item_image"></v-img>
                      </v-avatar>
                    </template>
                    <template v-slot:[`item.requested_quantity`]="{ item }">
                      <v-text-field
                        class="text-xs-center"
                        v-model="item.requested_quantity"
                        dense
                        type="number"
                        min="1"
                        :max="item.quantity"
                        @input="checkMaxQuantity(item)"
                        :suffix="can_edit ? `MAX-${item.quantity}` : ''"
                        :readonly="!can_edit"
                      >
                      </v-text-field>
                    </template>
                    <template v-slot:[`item.remove`]="{ item }">
                      <v-icon
                        color="error"
                        @click="removeItem(item)"
                        v-if="can_edit"
                        >cancel</v-icon
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>

          <v-dialog width="78vw" v-model="dialogAddItem">
            <dialog_articles
              v-if="dialogAddItem"
              @selected-item="addItem"
              :removeItemSelected="false"
              :showWarehouse="false"
              :data="{
                location: filters.location.id,
                business: filters.location.bus_id,
                warehouse: filters.warehouse.id,
                catalogue: filters.location.catalogue_id,
              }"
              @close-item="dialogAddItem = false"
            />
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
       <DialogConfirm
        :showDialog="dialogConfirm"
        :loading="loading_save"
        @closeDialog="save"
        size="45%"
        :confirm_settings="{ btn_affirmative: 'Si, continuar!', btn_negative: 'No, Cancelar!',icon: 'warning', title: 'Seguro que desea realizar este movimiento?',size: '45%' }"
        />
  </v-container>
</template>
<script>
import dialog_articles from "@/components/Inventory/CatalogeForAdjustment.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
import moment from "moment";
export default {
  data: () => ({
    can_edit: true,
    dialogConfirm:false,
    loading_save:false,
    search: "",
    page: 1,
    search_history: "",
    headersArticle: [
      {
        align: "start",
        value: "item_image",
      },
      { text: "ID", value: "item_id" },
      { text: "Articulo", value: "item_name" },
      {
        text: "Cantidad",
        value: "requested_quantity",
        width: "10%",
        align: "center",
      },
      { text: "", value: "remove" },
    ],
    history_headers: [
      { text: "Codigo", value: "code" },
      { text: "Fecha", value: "formatted_date" },
      { text: "ID origen", value: "from_warehouse_id" },
      { text: "Ubicacion origen", value: "from_warehouse_name" },
      { text: "ID destino", value: "to_warehouse_id" },
      { text: "Ubicacion destino", value: "to_warehouse_name" },
      { text: "Responsable", value: "use_fullname" },
    ],
    item_history: [],
    searchTerm: "",
    warehouse_from_menu_open: false,
    warehouse_to_menu_open: false,
    internalSearchTerm: "",
    loadingWarehouses: false,
    warehouseTree: [],
    all_warehouses: [],
    warehouseActive: [],
    warehouseSelected: [],
    loading: false,
    filters: {
      location: { catalogue_id: null, id: null },
      business: null,
      warehouse: { id: null, name: null },
      dateStart: moment().startOf("month").format("YYYY-MM-DD"),
      dateEnd: moment().endOf("month").format("YYYY-MM-DD"),
    },
    show_all_option: true,
    dialogAddItem: false,
    item_list: [],
    show_parents: true,
    warehouse_selected: null,
    headerTransfer: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Fecha", value: "created_at" },
      { text: "Solicitante", value: "use_fullname" },
      { text: "Location solicitado", value: "location_from" },
      { text: "Desde la ubicacion", value: "warehause_from" },
      { text: "Estatus", value: "status_description" },
      { text: "", value: "options", sortable: false },
    ],
    init: true,
  }),
  components: {
    dialog_articles,
    DialogConfirm
  },
  computed: {
    locationsFrombusiness() {
      let data = Object.assign(this.$store.state.auth.locations.filter((element) => element.bus_id == this.business_selected),[]);
      return data;
    },
    business_selected: {
      get() {
        return this.$store.state.app.filters.business;
      },
      set(value) {
        this.$store.commit("setBusiness", value);
      },
    },
    location_selected: {
      get() {
        if (this.init) {
          this.init = false;
          this.refresFilters();
        }
        return this.$store.state.app.filters.location;
      },
      set(value) {
        this.$store.commit("setLocation", value);
      },
    },
    currentTreeData() {
      return this.warehouseTree;
    },
    warehouse_from_display_text() {
      if (this.filters.warehouse && this.filters.warehouse.id === 0) {
        return "Todos las ubicaciones";
      } else if (this.filters.warehouse && this.filters.warehouse.name) {
        return this.filters.warehouse.name;
      } else {
        return "Seleccionar Ubicacion";
      }
    },
    customFilter() {
      return (item, search, textKey) => {
        if (!search) return true;

        const searchLower = search.toLowerCase();

        // Buscar en nombre
        if (item.name && item.name.toLowerCase().includes(searchLower)) {
          return true;
        }

        // Buscar en dirección
        if (item.address && item.address.toLowerCase().includes(searchLower)) {
          return true;
        }

        // Buscar en ubicación
        if (
          item.location_description_short &&
          item.location_description_short.toLowerCase().includes(searchLower)
        ) {
          return true;
        }

        if (
          item.location_description_long &&
          item.location_description_long.toLowerCase().includes(searchLower)
        ) {
          return true;
        }

        return false;
      };
    },
    warehouses_to() {
      this.warehouse_selected = null;
      if (this.filters.warehouse.id == null) {
        return [{ id: 0, name: "Escoja la ubicacion de origen" }];
      }
      // if (this.filters.warehouse.isParent) {
      //   return []
      // }
      let warehouse_origin = this.all_warehouses.find((element) => element.id == this.filters.warehouse.id);

      if(warehouse_origin.parent_warehouse_id == null){
        return this.all_warehouses.filter((element) => element.parent_warehouse_id == this.filters.warehouse.id);
      }
      let childrens = this.all_warehouses.filter((element) => element.parent_warehouse_id == warehouse_origin.parent_warehouse_id);
      if(childrens.length == 0){
        return [];
      }
      return this.all_warehouses.filter((element) => element.parent_warehouse_id == warehouse_origin.parent_warehouse_id && element.id != warehouse_origin.id);
    },
  },
  watch: {
    "filters.warehouse"() {
      this.refresFilters();
    },

    // WATCHER ARREGLADO - IGUAL QUE WAREHOUSE.VUE
    searchTerm(newVal, oldVal) {
      // Limpiar timeout anterior
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Si hay texto, activar búsqueda con debounce
      if (newVal && newVal.trim()) {
        this.searchTimeout = setTimeout(() => {
          this.activateSearch();
          this.internalSearchTerm = newVal;
          this.filterWarehouseTree();
        }, 300);
      } else {
        // Si se borra, desactivar búsqueda inmediatamente
        this.deactivateSearch();
        this.internalSearchTerm = "";
        this.searchMatchCount = 0;
        this.resetToOriginalTree();
      }
    },
  },
  methods: {
    async get_history() {
      try {
        const response = await this.api_Post("inventory/history_immediate_movements",
          {
            location_id: this.filters.location.id || this.filters.location.value,
            from_warehouse_id: this.filters.warehouse.isParent ? null: this.filters.warehouse.id,
            to_warehouse_id: this.warehouse_selected && this.warehouse_selected.id > 0 ? this.warehouse_selected.id : null,
          }
        );
        if (response.status === 200) {
          const data = await response.json();
          this.item_history = data;
          //   this.item_history.forEach((element) => {
          //     element.from_warehouse = `${element.from_warehouse_id}-${element.from_warehouse_name}`;
          //     element.to_warehouse = `${element.to_warehouse_id}-${element.to_warehouse_name}`;
          //   });
        } else {
          console.error("Error al obtener el historial de transferencias");
        }
      } catch (error) {
        console.error(
          "Error al obtener el historial de transferencias:",
          error
        );
      }
    },
    addItem(item) {
      let existArticle = this.item_list.find(
        (element) => element.item_id == item.item_id
      );
      if (existArticle != undefined) {
        this.$toast.warning("Este articulo ya se encuentra en la lista!");
        return;
      }
      this.item_list.push({
        item_id: item.item_id,
        item_name: item.item_name,
        quantity: item.quantity,
        requested_quantity: 1,
        received_quantity: 0,
        item_image: item.item_image,
      });
      this.dialogAddItem = false;
    },
    handleSelectedUpdate(items) {
      this.selectWarehouse(items);
    },
    refresFilters() {
      this.filters.business = this.business_selected;
      this.filters.location = this.location_selected;
      const business = this.$store.state.auth.bussines_units.find(
        (element) => element.id == this.business_selected
      );
      this.filters.business_unit = {
        id: business.id,
        name: business.description_long,
      };
      this.get_history();
    },
    setActiveWarehouseInTree(warehouseId) {
      this.warehouseActive = [];

      const findNodeById = (nodes) => {
        for (const node of nodes) {
          if (node.id === warehouseId) {
            this.warehouseActive = [node];
            return true;
          }

          if (node.children && node.children.length > 0) {
            if (findNodeById(node.children)) {
              return true;
            }
          }
        }

        return false;
      };

      findNodeById(this.warehouseTree);
    },
    isNodeHighlighted(node) {
      if (!this.searchTerm || !node) return false;
      return this.customFilter(node, this.searchTerm);
    },
    highlightSearchText(text) {
      if (!text || !this.searchTerm) {
        return text || "";
      }

      const searchTerm = this.searchTerm.toLowerCase();
      const textLower = text.toLowerCase();

      if (!textLower.includes(searchTerm)) {
        return text;
      }

      const regex = new RegExp(`(${this.escapeRegex(this.searchTerm)})`, "gi");
      return text.replace(regex, '<mark class="search-highlight">$1</mark>');
    },
    handleOpenUpdate(nodes) {
      if (!this.isSearchActive) {
        this.expandedNodes = nodes;
      }
    },
    refres_filters() {
      if (this.business_selected) {
        filters = ` WHERE w.BUSINESS_UNITS_ID = ${this.business_selected}`;
        if (
          this.location_selected &&
          this.location_selected.value &&
          this.location_selected.value !== 0
        ) {
          filters += ` AND w.LOCATION_ID = ${this.location_selected.value}`;
        }
      }
      this.get_warehouses({ filters });
    },
    selectWarehouse(nodes) {
      if (nodes.length > 0) {
        const selectedNode = nodes[0];

        this.warehouseSelected = [selectedNode];
        this.warehouseActive = [selectedNode];

        this.filters.warehouse = {
          id: selectedNode.id,
          name: selectedNode.name,
          isParent: selectedNode.children && selectedNode.children.length > 0,
          path: this.getWarehousePath(selectedNode),
        };

        this.warehouse_from_menu_open = false;
        // this.refresFilters();
      } else {
        this.warehouseSelected = [];
        this.warehouseActive = [];
      }
    },
    handleActiveUpdate(items) {
      this.selectWarehouse(items);
    },
    selectAllWarehouses() {
      this.filters.warehouse = {
        id: 0,
        name: "Todos",
        path: "Todas las ubicaciones",
      };
      this.warehouseActive = [];
      this.warehouse_from_menu_open = false;
    },
    clearSearch() {
      this.searchTerm = "";
      this.deactivateSearch();
      this.resetToOriginalTree();
    },
    expandAllNodes() {
      this.loading = true;

      try {
        const getAllParentNodeIds = (nodes) => {
          let ids = [];
          nodes.forEach((node) => {
            if (node.children && node.children.length > 0) {
              ids.push(node.id);
              ids = ids.concat(getAllParentNodeIds(node.children));
            }
          });
          return ids;
        };

        const parentIds = getAllParentNodeIds(this.currentTreeData);

        setTimeout(() => {
          this.expandedNodes = parentIds;

          const treeComponent = this.$refs.warehouseTree;
          if (treeComponent) {
            treeComponent.$forceUpdate();
            if (treeComponent.updateAll) {
              treeComponent.updateAll(true);
            }
          }

          this.loading = false;
        }, 200);
      } catch (error) {
        console.error("Error al expandir nodos:", error);
        this.loading = false;
      }
    },
    collapseAllNodes() {
      this.loading = true;

      try {
        if (this.isSearchActive) {
          this.clearSearch();
        }

        this.expandedNodes = [];

        const treeView = this.$refs.warehouseTree;
        if (treeView) {
          setTimeout(() => {
            treeView.$forceUpdate();
            this.loading = false;
          }, 100);
        } else {
          this.loading = false;
        }
      } catch (error) {
        console.error("Error al colapsar el árbol:", error);
        this.loading = false;
      }
    },
    async loadWarehouseTree() {
      this.loadingWarehouses = true;
      try {
        let filters = "";
        if (this.business_selected) {
          filters = ` WHERE w.BUSINESS_UNITS_ID = ${this.business_selected}`;
          if (
            this.location_selected &&
            this.location_selected.value &&
            this.location_selected.value !== 0
          ) {
            filters += ` AND w.LOCATION_ID = ${this.location_selected.value}`;
          }
        }

        const data = { filters };
        const response = await this.api_Post("inventory/warehouse/tree", data);

        if (response.status === 200) {
          const result = await response.json();
          this.all_warehouses = result;
          this.warehouseTree = this.buildTree(result);
          // ARREGLO: Guardar árbol original para búsquedas
          this.originalWarehouseTree = JSON.parse(
            JSON.stringify(this.warehouseTree)
          );

          // Limpiar búsqueda al cargar nuevos datos
          this.clearSearch();

          // Si ya hay un almacén seleccionado, establecer el nodo activo
          if (this.filters.warehouse && this.filters.warehouse.id) {
            this.setActiveWarehouseInTree(this.filters.warehouse.id);
          }
        } else {
          console.error("Error al cargar las ubicaciones");
          this.warehouseTree = [];
          this.originalWarehouseTree = [];
        }
      } catch (error) {
        console.error("Error al cargar el árbol de ubicaciones:", error);
        this.warehouseTree = [];
        this.originalWarehouseTree = [];
      } finally {
        this.loadingWarehouses = false;
      }
    },
    buildTree(items) {
      const itemMap = {};
      const roots = [];

      // Create item map
      items.forEach((item) => {
        itemMap[item.id] = { ...item, children: [] };
      });

      // Build tree
      items.forEach((item) => {
        if (item.parent_warehouse_id === null) {
          roots.push(itemMap[item.id]);
        } else if (itemMap[item.parent_warehouse_id]) {
          // Only add children if show_parents is true
          if (this.show_parents) {
            itemMap[item.parent_warehouse_id].children.push(itemMap[item.id]);
          }
        }
      });

      return roots;
    },
    deactivateSearch() {
      if (this.isSearchActive) {
        this.isSearchActive = false;

        // Restaurar estado previo
        this.$nextTick(() => {
          this.expandedNodes = [...this.savedExpandedNodes];
          this.savedExpandedNodes = [];
        });
      }
    },
    resetToOriginalTree() {
      if (this.originalWarehouseTree.length > 0) {
        this.warehouseTree = JSON.parse(
          JSON.stringify(this.originalWarehouseTree)
        );
      }
      this.expandedNodes = [];
      this.isSearchActive = false;
      this.searchMatchCount = 0;
    },
    getWarehousePath(node) {
      return node.name;
    },
    openDialogAddItem() {
      this.dialogAddItem = true;
    },
    checkMaxQuantity(item) {
      if (parseInt(item.requested_quantity) > parseInt(item.quantity)) {
        // Si el valor excede el máximo permitido, ajustarlo y mostrar una alerta
        item.requested_quantity = null;
        this.$toast.warning(
          "La cantidad solicitada excede la cantidad disponible"
        );
      }
      item.received_quantity = item.requested_quantity;
    },
    removeItem(item) {
      let index = this.item_list.indexOf(item);
      this.item_list.splice(index, 1);
    },
    async save(response) {
        if (!response) {
          this.dialogConfirm = false;
          return;
        }
        this.loading_save = true;
      try {
        const request = await this.api_Post("inventory/save_transfer", {
          transfer_id: null,
          location_from: this.filters.location.id,
          location_to: this.warehouse_selected.location_id,
          warehouse_from: this.filters.warehouse.id,
          warehouse_to: this.warehouse_selected.id,
          user_id: this.$store.state.auth.user.user.user_id,
          approval_type_id: 0,
          items: this.item_list,
        });
        const data = await request.json();
        if (request.status == 200) {
          this.$toast.success("Guardado correctamente!");
          this.get_history();
          this.page = 1;
        } else {
          this.$toast.error("Error al registrar el movimiento!." + data.error);
        }
      } catch (error) {
        this.$toast.error("Error al guardar el movimiento: " + error.message);
      }
        this.loading_save = false;
        this.dialogConfirm = false;
    },
    view_transfer(id) {
      let route = this.$router.resolve({
        name: "ViewTransfer",
        params: { id: id },
      });
      window.open(route.href);
    },
    new_transfer() {
      if(this.filters.warehouse.id==null){
        this.$toast.warning("Debe seleccionar una ubicacion de origen");
        return;
      }
      if(this.warehouse_selected == null) {
        this.$toast.warning("Debe seleccionar una ubicacion de destino");
        return;
      }
      this.item_list = [];
     this.page = 2;
    },
    validate_save(){
        if (this.item_list.length == 0) {
            this.$toast.warning("Debe agregar al menos un articulo");
            return;
        }
        if(this.item_list.some(item => item.requested_quantity <= 0)) {
            this.$toast.warning("Debe ingresar una cantidad valida para todos los articulos");
            return;
        }
        this.dialogConfirm = true;
    }
  },
};
</script>
<style scoped>
.origin-link {
  color: var(--v-primary-base);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  border-bottom: 1px solid transparent;
}

.origin-link--hover {
  color: var(--v-error-base);
  text-decoration: underline;
  border-bottom-color: var(--v-error-base);
  transform: translateY(-1px);
}
</style>